export default __webpack_public_path__ + "static/media/23.c62b57c9.jpg";